import React, { useState, useEffect } from "react";
import axios from 'axios';
import { Favorite } from "@material-ui/icons";
import "bootstrap/dist/css/bootstrap.min.css";
import "./bookmark.css";
import { auth, db } from '../firebase'; // Import db from firebase
import { getFirestore, collection, getDoc, query, orderBy, doc, deleteDoc, updateDoc } from "firebase/firestore";

const firestoreApiBaseUrl = "https://firestore.googleapis.com/v1/projects/scholarship-10c69/databases/(default)/documents";

const Bookmark = ({ isDarkMode, toggleTheme }) => {
    const [allScholarships, setAllScholarships] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [isOnline, setIsOnline] = useState(navigator.onLine);
    const user = auth.currentUser;
    const [expandedScholarship, setExpandedScholarship] = useState(null); // Change to null

    useEffect(() => {
        fetchAllScholarships();
        window.addEventListener("online", handleOnlineStatus);
        window.addEventListener("offline", handleOnlineStatus);

        return () => {
            window.removeEventListener("online", handleOnlineStatus);
            window.removeEventListener("offline", handleOnlineStatus);
        };
    }, []);

    const handleOnlineStatus = () => {
        setIsOnline(navigator.onLine);
    };

    const fetchAllScholarships = async () => {
        try {
            if (!user || !isOnline) {
                setError("You are either not logged in or currently offline. Please log in and connect to the internet.");
                return;
            }

            setLoading(true);
            const response = await axios.get(`${firestoreApiBaseUrl}/bookmark`);
            const fetchedScholarships = parseScholarships(response.data.documents);
            const userScholarships = fetchedScholarships.filter((scholarship) => scholarship.data.userEmail === user.email);
            setAllScholarships(userScholarships);
        } catch (error) {
            console.error("Error fetching scholarships: ", error);
            setError("Error fetching scholarships. Please try again later.");
        } finally {
            setLoading(false);
        }
    };

    const toggleExpand = (scholarshipId) => {
        setExpandedScholarship((prevExpanded) => (prevExpanded === scholarshipId ? null : scholarshipId));
    };

    const handleLike = async (id) => {
        try {
            const filteredScholarships = allScholarships.filter(scholarship => scholarship.scholarshipId !== id);
            setAllScholarships(filteredScholarships);
            await removeScholarshipFromBookmark(id);
            await markAsExpired(id); // Mark the scholarship as expired
            console.log(`Scholarship with ID: ${id} removed from bookmark and marked as expired.`);
        } catch (error) {
            console.error("Error handling like: ", error);
        }
    };


    const removeScholarshipFromBookmark = async (id) => {
        try {
            // Implement the logic to remove the scholarship from the bookmark in Firestore
            // This can be done using db.delete(), assuming your Firestore structure is correct
        } catch (error) {
            console.error("Error removing scholarship from bookmark: ", error);
        }
    };

    const markAsExpired = async (id) => {
        try {
            const firestoreDb = getFirestore();
            const scholarshipRef = doc(firestoreDb, "bookmark", id);

            // Check if the document exists
            const docSnapshot = await getDoc(scholarshipRef);
            if (!docSnapshot.exists()) {
                console.error("Document does not exist:", id);
                return;
            }

            // Update the scholarship document to mark it as expired
            await updateDoc(scholarshipRef, {
                expired: true,
            });

            // Remove the scholarship document from the bookmark collection
            await deleteDoc(scholarshipRef);

            // Refresh scholarships after marking one as expired and removing it from bookmark
            fetchAllScholarships();
        } catch (error) {
            console.error("Error marking scholarship as expired: ", error);
        }
    };


    const parseScholarships = (documents) => {
        return documents.map((doc) => {
            const data = doc.fields || {};
            const scholarshipDetails = data.scholarshipDetails ? data.scholarshipDetails.mapValue.fields : {};
            return {
                scholarshipId: doc.name.split("/").pop(),
                data: {
                    scholarshipDetails: {
                        title: scholarshipDetails.title ? scholarshipDetails.title.stringValue : "No title available",
                        description: scholarshipDetails.description ? scholarshipDetails.description.stringValue : "No description available",
                        eligibility: scholarshipDetails.eligibility ? scholarshipDetails.eligibility.stringValue : "No eligibility information available",
                        deadline: scholarshipDetails.deadline ? scholarshipDetails.deadline.stringValue : "No deadline information available",
                        country: scholarshipDetails.country ? scholarshipDetails.country.stringValue : "No Country information available",
                        link: scholarshipDetails.link ? scholarshipDetails.link.stringValue : 'No link available',
                        link1: scholarshipDetails.link1 ? scholarshipDetails.link1.stringValue : 'No link available',
                        imageUrl: scholarshipDetails.imageUrl ? scholarshipDetails.imageUrl.stringValue : null,
                    },
                    userEmail: data.userEmail ? data.userEmail.stringValue : "No user email available",
                }
            };
        });
    };

    return (
        <div className={`container mt-5 ${isDarkMode ? 'dark-mode' : 'light-mode'}`} style={{ backgroundColor: isDarkMode ? '#333' : '#f8f9fa', minHeight:"100vh" }}>
            <h3 className="mb-4 text-center" style={{ width: "100%", maxWidth: "fit-content", margin: "0 auto", wordWrap: "break-word", fontSize: "0.5rem" }}>Save Scholarships</h3>
            {allScholarships.length === 0 ? (
                <p className="text " style={{color: isDarkMode ? '#fff' : '#000',marginLeft:"30%"}} >No favorites saved.</p>
            ) : (
                <div className="row">
                    {allScholarships.map(({ scholarshipId, data }) => (
                        <div key={scholarshipId} className="col-lg-8 col-md-6 col-sm-12 mb-4">
                            <div className="card h-100">
                                {data.scholarshipDetails.imageUrl && (
                                    <img
                                        src={data.scholarshipDetails.imageUrl}
                                        alt="Scholarship"
                                        className="card-img-top img-fluid"
                                    />
                                )}
                                <div className="card-body" style={{ maxWidth: "100%" }}>
                                    <div className="d-flex align-items-center justify-content-between">
                                        <h4 className="card-title mb-0 fw-bold" style={{ overflowWrap: "break-word", maxWidth: "100%",textAlign: "left" }}>{data.scholarshipDetails.title}</h4>
                                    </div>
                                    <p className="card-text" style={{ overflowWrap: "break-word", textAlign: "left" }}>
                                        {expandedScholarship? data.scholarshipDetails.description : `${data.scholarshipDetails.description.slice(0, 100)}...`}
                                    </p>
                                    {expandedScholarship && (
                                        <>
                                            <p className="card-text" style={{ overflowWrap: "break-word", textAlign: "left" }}>
                                                <strong>Eligibility:</strong>{" "}{data.scholarshipDetails.eligibility}
                                            </p>
                                            <p className="card-text" style={{ overflowWrap: "break-word", textAlign: "left" }}>
                                                <strong>Deadline:</strong>{" "}{data.scholarshipDetails.deadline}
                                            </p>
                                            <p className="card-text" style={{ overflowWrap: "break-word", textAlign: "left" }}>
                                                <strong>Country:</strong>{" "}{data.scholarshipDetails.country}
                                            </p>
                                            {/* Render the links if they exist */}
                                            {(data.scholarshipDetails.link || data.scholarshipDetails.link1) ? (
                                                <>
                                                    {data.scholarshipDetails.link && (
                                                        <div className="card-text" style={{ overflowWrap: "break-word", textAlign: "left" }}>
                                                            <strong>Link:</strong>{" "}
                                                            <a
                                                                href={data.scholarshipDetails.link}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                {data.scholarshipDetails.link}
                                                            </a>
                                                        </div>
                                                    )}
                                                    {data.scholarshipDetails.link1 && (
                                                        <div className="card-text" style={{ overflowWrap: "break-word", textAlign: "left" }}>
                                                            <strong>Link:</strong>{" "}
                                                            <a
                                                                href={data.scholarshipDetails.link1}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                {data.scholarshipDetails.link1}
                                                            </a>
                                                        </div>
                                                    )}
                                                </>
                                            ) : (
                                                <div className="card-text" style={{ overflowWrap: "break-word", textAlign: "left" }}>
                                                    No links available
                                                </div>
                                            )}
                                        </>
                                    )}
                                    <div className="text-end" style={{ marginTop: "4%" }}> {/* Align to the right */}
                                        <button
                                            className={`read-more-button btn btn-secondary ${window.innerWidth < 576 ? 'btn-sm' : ''}`} // Apply btn-sm class when screen width is less than 576px
                                            onClick={() => toggleExpand(scholarshipId)}
                                            style={{
                                                transition: 'opacity 1.0s ease',
                                                backgroundColor: isDarkMode ? "#333" : "#333",
                                                color: isDarkMode ? "white" : "white",
                                            }}
                                        >
                                            {expandedScholarship === scholarshipId ? "Read less" : "Read more"}
                                        </button>
                                    </div>
                                    <p className="card-text" style={{ overflowWrap: "break-word", textAlign: "left", wordWrap: "anywhere" }}>
                                        User Email: {data.userEmail}
                                    </p>

                                </div>
                                <div className="text-center">
                                    <button
                                        className={`like-button btn btn-primary`}
                                        style={{ backgroundColor: 'red', color: 'white' }}
                                        onClick={() => handleLike(scholarshipId)}
                                    >
                                        <Favorite />
                                    </button>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}
            {loading && <p className="mt-3 text-center">Loading...</p>}
            {error && <p className="mt-3 text-danger text-center">{error}</p>}
        </div>
    );
}

export default Bookmark;
